export default "__VITE_ASSET__BDzSgCGt__"